module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "center",
    attrs: {
      "id": "TOC"
    }
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/4start#chap1"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/6chap2#chap2"
    }
  }, [_vm._v("ONE: The Shades of Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/7chap3#chap3"
    }
  }, [_vm._v("1. Before the Sun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/8chap4#chap4"
    }
  }, [_vm._v("2. Down in the Dark")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/9chap5#chap5"
    }
  }, [_vm._v("3. The Invader ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/10chap6#chap6"
    }
  }, [_vm._v("4. Wasps at Easter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/11chap7#chap7"
    }
  }, [_vm._v("5. The Death of a Bike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/12chap8#chap8"
    }
  }, [_vm._v("6. Old Moses Comes to Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/13chap9#chap9"
    }
  }, [_vm._v("7. A Summons From the Lady")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/14chap10#chap10"
    }
  }, [_vm._v("TWO: A Summer of Devils and Angels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/15chap11#chap11"
    }
  }, [_vm._v("1. Last Day of School")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/16chap12#chap12"
    }
  }, [_vm._v("2. Barbershop Talk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/17chap13#chap13"
    }
  }, [_vm._v("3. A Boy And a Ball")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/18chap14#chap14"
    }
  }, [_vm._v("4. I Get Around")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/19chap15#chap15"
    }
  }, [_vm._v("5. Welcome, Lucifer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/20chap16#chap16"
    }
  }, [_vm._v("6. Nemo’s Mother & A Week With the Jaybird")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/21chap17#chap17"
    }
  }, [_vm._v("7. My Camping Trip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/22chap18#chap18"
    }
  }, [_vm._v("8. Chile Willow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/23chap19#chap19"
    }
  }, [_vm._v("9. Summer Winds Up")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/24chap20#chap20"
    }
  }, [_vm._v("THREE: Burning Autumn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/25chap21#chap21"
    }
  }, [_vm._v("1. Green-Feathered Hat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/26chap22#chap22"
    }
  }, [_vm._v("2. The Magic Box")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/27chap23#chap23"
    }
  }, [_vm._v("3. Dinner With Vernon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/28chap24#chap24"
    }
  }, [_vm._v("4. The Wrath of Five Thunders")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/29chap25#chap25"
    }
  }, [_vm._v("5. Case #3432")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/30chap26#chap26"
    }
  }, [_vm._v("6. Dead Man Driving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/31chap27#chap27"
    }
  }, [_vm._v("7. High Noon In Zephyr")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/32chap28#chap28"
    }
  }, [_vm._v("8. From the Lost World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/33chap29#chap29"
    }
  }, [_vm._v("FOUR: Winter’s Cold Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/34chap30#chap30"
    }
  }, [_vm._v("1. A Solitary Traveler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/35chap31#chap31"
    }
  }, [_vm._v("2. Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/36chap32#chap32"
    }
  }, [_vm._v("3. Snippets Of The Quilt")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/37chap33#chap33"
    }
  }, [_vm._v("4. Mr. Moultry’s Castle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/38chap34#chap34"
    }
  }, [_vm._v("5. Sixteen Drops Of Blood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/39chap35#chap35"
    }
  }, [_vm._v("6. The Stranger Among Us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/40chap36#chap36"
    }
  }, [_vm._v("FIVE: Zephyr as It is")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Book3/41acknowledgments#acknowledgments"
    }
  }, [_vm._v("Acknowledgements")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f51be3f2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book3/3-TOC.vue
// module id = 84
// module chunks = 0